import { useAuth } from './useAuth';
import { useApi } from './useApi';
import { useCallback } from 'react';
import { formatScoreString } from '../utils/scores';

// DISCLAIMER: use this hook when you are sure the userToken has been already instantiated
export const useFetchUserData = () => {
  const { api } = useApi();
  const { userToken } = useAuth();

  const getScoreSummary = useCallback(
    async ({ route, token }) => {
      const response = await api({
        route,
        token,
      });

      if (response) {
        const scoreObj = response.ayble_score_min;
        const rawScore = scoreObj ? response.ayble_score_min : 0;
        const formattedScore = formatScoreString(rawScore);
        return { lowest_ayble_score: formattedScore };
      }
      return { lowest_ayble_score: '0' };
    },
    [api]
  );

  const getUserAybleScoreSummary = useCallback(
    async (userId) => {
      return getScoreSummary({
        route: `/private/coach/users/${userId}/scores/summary`,
        token: userToken,
      });
    },
    [getScoreSummary, userToken]
  );

  return {
    getUserAybleScoreSummary,
  };
};
